<template>
  <div class="loading-wrapper" v-if="loading">
    <div class="loading-tv">
      <div class="loading-content">
        <span class="l l1"></span>
        <span class="l l2"></span>
        <span class="l l3"></span>
        <span class="l l4"></span>
        <span class="l l5"></span>
        <span class="l l6"></span>
        <span class="l l7"></span>
        <span class="l l8"></span>
        <span class="l l9"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["loading"],
  data() {
    return {};
  },
  methods: {},
  created() {
  },
  mounted() {
  },
  updated() {
  },
  computed: {},
  watch: {}
};
</script>
<style scoped></style>
